import { Field, Form, Formik } from 'formik'
import styled from 'styled-components'


export const ReceivementListContainer = styled.div`
`

export const FormContainer = styled.div`
  display: flex;
  align-items: center;
`

export const OptionLabel = styled.label.attrs(({htmlFor}) => ({
  htmlFor
}))`
`

export const OptionContainer = styled.div.attrs(() => ({
  className: 'form-group mr-5'
}))`
  display: flex;
  flex-direction: column;
`

export const ContainerSelect = styled(OptionContainer)`
  min-width: 180px;
`

export const TableContainer = styled(OptionContainer)`
 overflow-y: auto;
 height: 400px;
`
export const DateSelect = styled(Field)`
background: rgba(246, 246, 246, 0.6);
border: 0;
border-bottom: 3px solid #002d62;
`
